export default function courseStepFindByAccess(employeeId = 0) {
  const query = `{
    courseStepFindByAccess (employeeId: ${employeeId}) {
            id,
            fullName,
            cycleQuantity
            course {
              id,
              minNote,
              maxNote
            }            
            value, 
            label
          }
      }`;
  return query;
}
